import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { StoreDevtoolsName } from '../store-names.const'

import { layoutInitialState } from './layout.slice'
import type { LayoutStore, StartLoaderOptions } from './layout.type'

export type {
  LayoutSet,
  LayoutStore,
  LayoutStoreActions,
  LayoutStoreLoaderActions,
  LayoutStoreState,
  LayoutStoreSyncActions,
  StartLoaderOptions,
  VisionMode,
} from './layout.type'
export const useLayoutStore = create<LayoutStore>()(
  devtools(
    immer((set) => ({
      ...layoutInitialState,
      openCreateProjectDialog: () =>
        set((state) => {
          state.createProjectDialogOpen = true
        }),
      closeCreateProjectDialog: () =>
        set((state) => {
          state.createProjectDialogOpen = false
        }),
      setCreateProjectDialogOpen: (open) =>
        set((state) => {
          state.createProjectDialogOpen = open
        }),
      openInviteProjectDialog: () =>
        set((state) => {
          state.inviteProjectOpen = true
        }),
      closeInviteProjectDialog: () =>
        set((state) => {
          state.inviteProjectOpen = false
        }),
      setInviteProjectDialogOpen: (open) =>
        set((state) => {
          state.inviteProjectOpen = open
        }),
      openInviteWorkspaceDialog: () =>
        set((state) => {
          state.inviteWorkspaceOpen = true
        }),
      closeInviteWorkspaceDialog: () =>
        set((state) => {
          state.inviteWorkspaceOpen = false
        }),
      setInviteWorkspaceDialogOpen: (open) =>
        set((state) => {
          state.inviteWorkspaceOpen = open
        }),
      setFeedbackPopoverOpen: (open) =>
        set((state) => {
          state.feedbackPopoverOpen = open
        }),
      toggleMobileMenu: () =>
        set((state) => {
          state.mobileMenuOpen = !state.mobileMenuOpen
        }),
      closeMobileMenu: () =>
        set((state) => {
          state.mobileMenuOpen = false
        }),
      toggleSidebar: () =>
        set((state) => {
          state.sidebarCollapsed = !state.sidebarCollapsed
        }),
      startLoader: (message?: string, options?: StartLoaderOptions) =>
        set((state) => {
          state.loaderCount += 1
          state.isLoading = true
          if (message !== undefined) {
            state.loaderMessage = message
          }
          if (options?.showOnSettings) {
            state.showLoaderOnSettings = true
          }
        }),
      stopLoader: () =>
        set((state) => {
          state.loaderCount = Math.max(0, state.loaderCount - 1)
          if (state.loaderCount === 0) {
            state.isLoading = false
            state.loaderMessage = null
            state.showLoaderOnSettings = false
          }
        }),
      clearFullScreenLoader: () =>
        set((state) => {
          state.loaderCount = 0
          state.isLoading = false
          state.loaderMessage = null
          state.showLoaderOnSettings = false
        }),
    })),
    { name: StoreDevtoolsName.Layout, enabled: process.env.NODE_ENV === 'development' }
  )
)
